/**
 * THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY
 * To add new icons to the system, or to update existing icons, run `clyde mana assets sync -t icons`.
 */

import * as React from 'react';
import tokens from '@discordapp/tokens/web';

import addDefaultIconProps from '../addDefaultIconProps';
import {getIconSize} from '../getIconSize';

import type {SingleColorIconProps} from '../IconTypes';

/**
 * ![ImagesIcon](data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAAsTAAALEwEAmpwYAAABf0lEQVR4nN2UvUrEQBDHg6BiIYid2FuLtWh7eNmZCbI3Ey38KFJq4QOk9HwLwc5XsJJrPGx8BkELERu9xg9O9pLc5e6Sy+ZIowNThPx3frOzu3/H+XdRq9XmwZMTRXwHxB9A0s1N5Fap4vW6XgWUh4lFaZAK+bVc53FxRfLoor8LAItOVWHGkhTXWi87VYdCbhuA6dx8a63ngPhCIT9bj4z4CUiaZm0GQN57wngsRmhbOCOb4yOKf/aBUTfdOEOAxhZA48j1GhsK5btoJ4WA1E35RNxbH9Ja3DRrgBufSToQD5YA5aUSACBfaa0Xhs6LxDc7qwZA0kX0d4a1/FbZiCA6hzagXCvie0C+tLlJpQAwnh2FcqaIUZHc2AGQW2lvmeA/P+BJPdEFQTCrSG4LAXk7gkF+JW9iVOt5+yujL74MoOOSv93rFPkwDMOZLL1L/mb6ZpUBHBeK+2v41BqQWAURr9kCjI3kWsV4N9ObnUI5LwREdi3NEdOb3q7/bPwCCn7nhmYr3CMAAAAASUVORK5CYII=)
 */
export const ImagesIcon = ({
  size = 'md',
  width,
  height,
  color = tokens.colors.INTERACTIVE_NORMAL,
  colorClass = '',
  ...props
}: SingleColorIconProps) => {
  const iconSize = getIconSize(size);
  const iconWidth = iconSize?.width ?? width;
  const iconHeight = iconSize?.height ?? height;
  return (
    <svg
      {...addDefaultIconProps(props)}
      xmlns="http://www.w3.org/2000/svg"
      width={iconWidth}
      height={iconHeight}
      fill="none"
      viewBox="0 0 24 24">
      <path
        fill={typeof color === 'string' ? color : color.css}
        d="M4 8v7.5a.5.5 0 0 1-.5.5H3a1 1 0 0 1-1-1V8a6 6 0 0 1 6-6h7a1 1 0 0 1 1 1v.5a.5.5 0 0 1-.5.5H8a4 4 0 0 0-4 4Z"
        className={colorClass}
      />
      <path
        fill={typeof color === 'string' ? color : color.css}
        fillRule="evenodd"
        d="M6 9a3 3 0 0 1 3-3h10a3 3 0 0 1 3 3v10a3 3 0 0 1-3 3H9a3 3 0 0 1-3-3V9Zm13.8 9.79L16.82 15a2 2 0 0 0-3.14 0l-2.09 2.65-.13-.16a1.5 1.5 0 0 0-2.36.05l-.95 1.26a.75.75 0 0 0 .6 1.2h10.46c.62 0 .97-.72.59-1.21ZM11.73 8.3c.57-.56 1.52-.01 1.33.77a.8.8 0 0 0 .55.96c.77.22.77 1.3 0 1.53a.8.8 0 0 0-.55.96c.19.77-.76 1.32-1.33.76a.8.8 0 0 0-1.1 0c-.58.56-1.53.01-1.33-.76a.8.8 0 0 0-.56-.96c-.77-.22-.77-1.31 0-1.53a.8.8 0 0 0 .56-.96c-.2-.78.75-1.33 1.32-.77.31.3.8.3 1.11 0Z"
        clipRule="evenodd"
        className={colorClass}
      />
    </svg>
  );
};
